export interface LinkItem {
  title: string;
  href: string;
}

export const josaaLinks: LinkItem[] = [
  {
    title: "B.Tech Admission Fees Structure (JoSAA/CSAB/Sports/Olympiad)",
    href: "https://drive.google.com/file/d/1vemIWkvls_5Ynx31uEo2fyacJyHDgZXa/view?usp=sharing",
  },
  {
    title: "Hostel Fee Structure",
    href: "https://drive.google.com/file/d/1TZNjK_GEjStjE2HAEQ58fUguoJR6E94z/view?usp=sharing",
  },
  {
    title: "Physical reporting from 20th Aug 2025 to 23rd Aug 2025",
    href: "/docs/B.Tech._Admission_Guidelines_for_2025-26_Students.pdf",
  },
  {
    title:
      "Admission form for B.Tech students allotted through JoSAA/CSAB Counselling 2025",
    href: "https://forms.gle/HhFLbufmLBh8FwW56",
  },
  {
    title: "Fee Refund Policy",
    href: "/docs/Fee-Refund.pdf",
  },
  {
    title: "PM VIDYA LAXMI EDUCATION LOAN SCHEME - CANARA BANK",
    href: "/docs/PM_VIDYA_LAXMI_EDUCATION_LOAN_-CANARA_BANK_FOR_IIIT_DHARWAD.pdf",
  },
  {
    title: "Scholarships",
    href: "/scholarship/",
  },
  {
    title: "FAQ's",
    href: "/faq/",
  },
  {
    title:
      "Performance in Class XII for candidates seeking admission in IIIT Dharwad - 2026",
    href: "/docs/Performance_in%20Class_XII_2026.pdf",
  },
  {
    title:
      "Category wise Top-20 percentile cut-off marks out-of total 500 marks for 2026",
    href: "https://cdnbbsr.s3waas.gov.in/s313111c20aee51aeb480ecbd988cd8cc9/uploads/2026/06/2026060941.pdf",
  },
];

export const dasaLinks: LinkItem[] = [
  {
    title: "B.Tech Admission Fees Structure (Study in India/DASA)",
    href: "https://drive.google.com/file/d/1ExyeIsTPS2GCtol5W53ZbEk29YP9xfHb/view?usp=sharing",
  },
  {
    title: "Hostel Fee Structure",
    href: "https://drive.google.com/file/d/1TZNjK_GEjStjE2HAEQ58fUguoJR6E94z/view?usp=sharing",
  },
];

export const siiLinks: LinkItem[] = [
  {
    title: "B.Tech Admission Fees Structure (Study in India/DASA)",
    href: "https://drive.google.com/file/d/1ExyeIsTPS2GCtol5W53ZbEk29YP9xfHb/view?usp=sharing",
  },
  {
    title: "Hostel Fee Structure",
    href: "https://drive.google.com/file/d/1TZNjK_GEjStjE2HAEQ58fUguoJR6E94z/view?usp=sharing",
  },
  {
    title: "Study in India (SII) Official Website",
    href: "https://www.studyinindia.gov.in/",
  },
  {
    title: "General Admission Guidelines (SEA, OEA and SII)",
    href: "https://docs.google.com/document/d/1VMB7NvKJVvlVTA4_EvtELzk9ikDXHH3_7lGwrtoOl3w/edit?usp=sharing",
  },
];

export const sportsLinks: LinkItem[] = [
  {
    title: "B.Tech Admission Fees Structure (JoSAA/CSAB/Sports/Olympiad)",
    href: "https://drive.google.com/file/d/1vemIWkvls_5Ynx31uEo2fyacJyHDgZXa/view?usp=sharing",
  },
  {
    title: "Hostel Fee Structure",
    href: "https://drive.google.com/file/d/1TZNjK_GEjStjE2HAEQ58fUguoJR6E94z/view?usp=sharing",
  },
  {
    title: "Sports and Olympiad Application Form",
    href: "https://forms.gle/rWUJz8UECf2KLnAA8",
  },
  {
    title: "General Admission Guidelines (SEA, OEA and SII)",
    href: "https://docs.google.com/document/d/1VMB7NvKJVvlVTA4_EvtELzk9ikDXHH3_7lGwrtoOl3w/edit?usp=sharing",
  },
];

export const olympiadLinks: LinkItem[] = [
  {
    title: "B.Tech Admission Fees Structure (JoSAA/CSAB/Sports/Olympiad)",
    href: "https://drive.google.com/file/d/1vemIWkvls_5Ynx31uEo2fyacJyHDgZXa/view?usp=sharing",
  },
  {
    title: "Hostel Fee Structure",
    href: "https://drive.google.com/file/d/1TZNjK_GEjStjE2HAEQ58fUguoJR6E94z/view?usp=sharing",
  },
  {
    title: "Sports and Olympiad Application Form",
    href: "https://forms.gle/rWUJz8UECf2KLnAA8",
  },
  {
    title: "General Admission Guidelines (SEA, OEA and SII)",
    href: "https://docs.google.com/document/d/1VMB7NvKJVvlVTA4_EvtELzk9ikDXHH3_7lGwrtoOl3w/edit?usp=sharing",
  },
];

// Fallback export to prevent build break in other potential imports
export const bTechAdmissionLinks = josaaLinks;
